import PropTypes from 'prop-types';
import React, { Component } from 'react';

class PlayPause extends Component {
  static contextTypes = {
    isPlaying: PropTypes.bool,
    playPause: PropTypes.func
  };

  _handlePlayPause = () => {
    this.context.playPause();
  };

  render() {
    return (
      <svg
        role="button"
        width="30px"
        height="30px"
        viewBox="8 8 20 20"
        className={this.props.className}
        onClick={this._handlePlayPause}
      >
        {/* <circle fill="#373D3F" cx="18" cy="18" r="18"/> */}
        {this.context.isPlaying && (
          <g key="pause" style={{ transformOrigin: '0% 50%' }}>
            <rect x="12" y="11" fill="rgba(255,255,255,0.94)" width="4" height="14" />
            <rect x="20" y="11" fill="rgba(255,255,255,0.94)" width="4" height="14" />
          </g>
        )}
        {!this.context.isPlaying && (
          <polygon
            key="play"
            fill="rgba(255,255,255,0.94)"
            points="14,11 26,18 14,25"
            style={{ transformOrigin: '100% 50%' }}
          />
        )}
      </svg>
    );
  }
}

export default PlayPause;
